$(document).ready(function(){

  //Product Embedder

  if( $('.product-embedder').length){
    var css = '//www.beautyrx.com/cdn/shop/t/101/assets/product-cta.scss.css?v=15321785650953804001764053899';
    $('head').append('<link rel="stylesheet" type="text/css" href="'+css+'">');
  }  

  $('.product-embedder').each(function(){
    var $this = $(this);
    var code = Math.random().toString(36).substring(2, 12); 
    var product_id = $this.data('product-id');
    var width = $this.data('width');  // full-width , article-width, half-article-width 
    if (typeof product_id !== "undefined") {

      var style_class = '';
      if(width=='full-width'){
        style_class = 'product-cta-fullpage-width';
      }else if(width=='article-width'){
        style_class = 'product-cta-article-width';
      }else if(width=='half-article-width'){
        style_class = 'product-cta-half-article-width';
      }

      var loading_image = '//www.beautyrx.com/cdn/shop/t/101/assets/fancybox_loading_2x.gif?v=151595797360954463041764047898';
      $this.addClass(style_class);
      $this.html('<div style="width:100%;text-align:center;"><img style="width:auto" src="'+loading_image+'"></div>');
      $.ajax({
        type: "GET",
        url: "/apps/beautyrx/product-cta-module/product.php?code="+code+"&id="+product_id,
      }).done(function(result){       
        var code = '';
        if(result.status){
          var product = result.product;
          //var product_image = product.image.replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_600x600$1');
          var product_image = product.image;
          if(width=='full-width'){  //Full-width
            code += '<div class="wr-product-cta">';
            code += '<div class="wrapp-image-product"><img class="img-pro" src="'+product_image+'" alt/></div>';
            code += '<div class="info-product-cta">';
            code += '<h2>Dr. Schultz Recommends:</h2>';
            code += '<div class="line-cta"></div>';
            code += '<div class="text-product-cta">';
            code += '<h4>'+product.title+'</h4>';
            code += '<p>'+product.excerpt+'</p>';
            code += '<a href="/products/'+product.handle+'">shop now</a>';
            code += '</div>';
            code += '</div>';
            code += '</div>';
          }else if(width=='article-width'){  //Article Width
            code += '<div class="wr-product-cta">';
            code += '<div class="wrapp-image-product"><img class="img-pro" src="'+product_image+'" alt/></div>';
            code += '<div class="info-product-cta">';
            code += '<h2>Dr. Schultz Recommends:</h2>';
            code += '<div class="line-cta"></div>';
            code += '<div class="text-product-cta">';
            code += '<h4>'+product.title+'</h4>';
            code += '<p>'+product.excerpt+'</p>';
            code += '<a href="/products/'+product.handle+'">shop now</a>';
            code += '</div>';
            code += '</div>';
            code += '</div>';
          }else if(width=='half-article-width'){ //Half Article Width
            code += '<div class="wr-product-cta">';
            code += '<h2>Dr. Schultz Recommends:</h2>';
            code += '<div class="wrapp-image-product"><img class="img-pro" src="'+product_image+'" alt/></div>';
            code += '<div class="info-product-cta">';
            code += '<h4>'+product.title+'</h4>';
            code += '<p>'+product.excerpt+'</p>';
            code += '<a href="/products/'+product.handle+'">shop now</a>';
            code += '</div>';
            code += '</div>';
          }          
          $this.html(code);
        }else{
          $this.remove();
        }     
      });
    }
  });


  //Digital Booklet

  if( $('.digital-booklet').length){
    var css = '//www.beautyrx.com/cdn/shop/t/101/assets/digital-booklet.scss.css?v=108352274426764344791764053899';
    $('head').append('<link rel="stylesheet" type="text/css" href="'+css+'">');
  } 

  $('.digital-booklet').each(function(){
    var $this = $(this);
    var code = Math.random().toString(36).substring(2, 12); 
    var list_id = $this.data('list-id');
    var width = $this.data('width');  // full-width , article-width, half-article-width 
    if (typeof list_id !== "undefined") {
      var style_class = '';
      if(width=='full-width'){
        style_class = 'booklet-fullpage-width';
      }else if(width=='article-width'){
        style_class = 'booklet-article-width';
      }else if(width=='half-article-width'){
        style_class = 'booklet-half-article-width';
      }
      var loading_image = '//www.beautyrx.com/cdn/shop/t/101/assets/fancybox_loading_2x.gif?v=151595797360954463041764047898';
      $this.addClass(style_class);
      $this.html('<div style="width:100%;text-align:center;"><img style="width:auto" src="'+loading_image+'"></div>');

      var code = '';
      if(width=='full-width'){  //Full-width
        code += '<div class="fullpage-column">';
        code += '<div class="wrapp-heading">';
        code += '<h4 class="booklet-sub-heading">Want instant insight on your skin?'; 
        code += '<span>Get your free copy of';
        code += '<br> Dr. Schultz’s booklet:</span></h4>';
        code += '<h2 class="booklet-heading">Prescription <span>for Gorgeous Skin</span></h2>';
        code += '</div>';
        code += '<div class="wr-image-booklet">';
        code += '<img class="img-booklet" src="//www.beautyrx.com/cdn/shop/t/101/assets/booklet.png?v=114438889822592106531764047831" alt/>';
        code += '</div>';
        code += '<div class="wrapp-form-booklet">';
        code += '<form class="digital-booklet-form" action="/">';
        code += '<div class="form-item">';
        code += '<input type="text" id="fname" name="first_name" value="" placeholder="Full Name" required>';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="email" id="email" class="email" name="email" placeholder="Email" required/>';
        code += '</div>';
        code += '<input type="hidden" name="list-id" value="'+list_id+'">';
        code += '<input class="submit-btn" type="submit" value="download now">';
        code += '</form> ';
        code += '</div>';
        code += '</div>';
      }else if(width=='article-width'){  //Article Width
        code += '<h4 class="booklet-sub-heading">Want instant insight on your skin?';
        code += '<span>Get your free copy of Dr. Schultz’s booklet:</span></h4>';
        code += '<h2 class="booklet-heading">Prescription for Gorgeous Skin</h2>';
        code += '<div class="wr-image-booklet">';
        code += '<img class="img-booklet" src="//www.beautyrx.com/cdn/shop/t/101/assets/booklet.png?v=114438889822592106531764047831" alt/>';
        code += '</div>';
        code += '<div class="wrapp-form-booklet">';
        code += '<form id="digital-booklet-form" class="klaviyo_gdpr_embed_'+list_id+' digital-booklet-form" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate">';
        code +=	'<input type="hidden" name="g" value="'+list_id+'">';
        code += '<input type="hidden" name="$fields" value="First Name">';
        code += '<input type="hidden" name="$list_fields" value="First Name">';
        code += '<div class="form-group">';
        code += '<div class="form-item klaviyo_field_group">';
        code += '<input type="text" id="fname" name="First Name" value="" placeholder="Full Name" required>';
        code += '</div>';
        code += '<div class="form-item klaviyo_field_group">';
        code += '<input type="email" id="email" class="email" name="email" placeholder="Email" required/>';
        code += '</div>';
        code += '</div>';
        code += '<div style="text-align:center;" class="klaviyo_messages">';
        code += '<div style="color: #009271;" class="success_message" style="display:none;"></div>';
        code += '<div style="color: red;" class="error_message" style="display:none;"></div>';
        code += '</div>';
        code += '<div class="klaviyo_form_actions">';
        code += '<input type="hidden" name="list-id" value="'+list_id+'">';
        code += '<input class="submit-btn klaviyo_submit_button" type="submit" value="download now">';
        code += '</div>';
        code += '</form>';
        code += '</div>';
        code += '<script type="text/javascript" src="//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"></script>';
      }else if(width=='half-article-width'){ //Half Article Width
        code += '<h4 class="booklet-sub-heading">Want instant insight on your skin?';
        code += '<span>Get your free copy<br>of Dr. Schultz’s booklet:</span></h4>';
        code += '<h2 class="booklet-heading">Prescription for Gorgeous Skin</h2>';
        code += '<div class="wr-image-booklet">';
        code += '<img class="img-booklet" src="//www.beautyrx.com/cdn/shop/t/101/assets/booklet.png?v=114438889822592106531764047831" alt/>';
        code += '</div>';
        code += '<div class="wrapp-form-booklet">';
        code += '<form id="digital-booklet-form" class="klaviyo_gdpr_embed_'+list_id+' digital-booklet-form" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate">';
        code +=	'<input type="hidden" name="g" value="'+list_id+'">';
        code += '<input type="hidden" name="$fields" value="First Name">';
        code += '<input type="hidden" name="$list_fields" value="First Name">';
        code += '<div class="form-item klaviyo_field_group">';
        code += '<input type="text" id="fname" name="first_name" value="" placeholder="Full Name" required>';
        code += '</div>';
        code += '<div class="form-item klaviyo_field_group">';
        code += '<input type="email" id="email" class="email" name="email" placeholder="Email" required/>';
        code += '</div>';
        code += '<div style="text-align:center;" class="klaviyo_messages">';
        code += '<div style="color: #009271;" class="success_message" style="display:none;"></div>';
        code += '<div style="color: red;" class="error_message" style="display:none;"></div>';
        code += '</div>';
        code += '<div class="klaviyo_form_actions">';
        code += '<input type="hidden" name="list-id" value="'+list_id+'">';
        code += '<input class="submit-btn" type="submit" value="download now">';
        code += '</div>';
        code += '</form>';
        code += '</div>';
        code += '<script type="text/javascript" src="//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"></script>';
      }          
      $this.html(code);
    }
  });

  KlaviyoSubscribe.attachToForms('#digital-booklet-form', {
    hide_form_on_success: true,
    extra_properties: {
      $source: 'Digital Booklet Form',
      $method_type: "Digital Booklet Inline With Content",
      $method_id: 'Embed',
      success: function ($form) {
        console.log("Submit Klaviyo Success");
      }
    },
    success_message: "Thanks for subscribing! Please check your email."
  });
  
  //Submit
  /*
  $(document).on('submit', '.digital-booklet-form', function(e) {
    e.preventDefault();
    var $form = $(this);
    var formData = $form.serialize();
    var code = Math.random().toString(36).substring(2, 12); 
    $.ajax({
      type        : 'POST',
      url		  : "/apps/beautyrx/product-cta-module/form.php?function=save-klaviyo-list&code="+code,
      data        : formData,
      dataType    : 'json',
      encode      : true
    }).done(function(data) {
      if(data.success){
        $form.html('<p style="text-align:center;">Thanks for subscribing! Please check your email.</p>');
      }else{
        alert(data.message);
      }      
    });
  });
  */


  //Hard Copy

  if( $('.hard-copy').length){
    var css = '//www.beautyrx.com/cdn/shop/t/101/assets/hard-copy.scss.css?v=22344909403572200141764053899';
    $('head').append('<link rel="stylesheet" type="text/css" href="'+css+'">');
  } 

  $('.hard-copy').each(function(){
    var $this = $(this);
    var code = Math.random().toString(36).substring(2, 12); 
    var list_id = $this.data('list-id');
    var width = $this.data('width');  // full-width , article-width, half-article-width 
    if (typeof list_id !== "undefined") {
      var style_class = '';
      if(width=='full-width'){
        style_class = 'booklet-fullpage-width';
      }else if(width=='article-width'){
        style_class = 'booklet-article-width';
      }else if(width=='half-article-width'){
        style_class = 'booklet-half-article-width';
      }
      var loading_image = '//www.beautyrx.com/cdn/shop/t/101/assets/fancybox_loading_2x.gif?v=151595797360954463041764047898';
      $this.addClass(style_class);
      $this.html('<div style="width:100%;text-align:center;"><img style="width:auto" src="'+loading_image+'"></div>');

      var code = '';
      if(width=='full-width'){  //Full-width
        code += '<div class="fullpage-column">';
        code += '<div class="wrapp-heading">';
        code += '<h4 class="booklet-sub-heading">Get your free hard copy';
        code += '<span>of Dr. Schultz’s booklet:</span></h4>';
        code += '<h2 class="booklet-heading">Prescription <span>for Gorgeous Skin</span></h2>';
        code += '<p class="small-text-booklet">Includes our digital newsletter — ';
        code += '<span>where Dr. Schultz shares his best tips and tricks</span></p>';
        code += '</div>';
        code += '<div class="wr-image-booklet hard-copy">';
        code += '<img class="img-booklet" src="//www.beautyrx.com/cdn/shop/t/101/assets/booklet.png?v=114438889822592106531764047831" alt/>';
        code += '</div>';
        code += '<div class="wrapp-form-booklet hard-copy">';
        code += '<form class="hard-copy-form" action="/">';
        code += '<div class="form-group">';
        code += '<div class="form-item">';
        code += '<input type="text" id="fname" name="first_name" value="" placeholder="Full Name" >';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="email" id="email" class="email" name="email" placeholder="Email" required/>';
        code += '</div>';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="text" id="street-address" name="$address1" value="" placeholder="Street Address" >';
        code += '</div>';
        code += '<div class="form-group">';
        code += '<div class="form-item">';
        code += '<input type="text" id="fcity" name="$city" value="" placeholder="City" >';
        code += '</div>';
        code += '<div class="form-item item-half">';
        code += '<select name="$region" id="state">';
        code += '<option value="" selected="selected">State</option>';
        code += '<option value="AL">Alabama</option>';
        code += '<option value="AK">Alaska</option>';
        code += '<option value="AZ">Arizona</option>';
        code += '<option value="AR">Arkansas</option>';
        code += '<option value="CA">California</option>';
        code += '<option value="CO">Colorado</option>';
        code += '<option value="CT">Connecticut</option>';
        code += '<option value="DE">Delaware</option>';
        code += '<option value="DC">District Of Columbia</option>';
        code += '<option value="FL">Florida</option>';
        code += '<option value="GA">Georgia</option>';
        code += '<option value="HI">Hawaii</option>';
        code += '<option value="ID">Idaho</option>';
        code += '<option value="IL">Illinois</option>';
        code += '<option value="IN">Indiana</option>';
        code += '<option value="IA">Iowa</option>';
        code += '<option value="KS">Kansas</option>';
        code += '<option value="KY">Kentucky</option>';
        code += '<option value="LA">Louisiana</option>';
        code += '<option value="ME">Maine</option>';
        code += '<option value="MD">Maryland</option>';
        code += '<option value="MA">Massachusetts</option>';
        code += '<option value="MI">Michigan</option>';
        code += '<option value="MN">Minnesota</option>';
        code += '<option value="MS">Mississippi</option>';
        code += '<option value="MO">Missouri</option>';
        code += '<option value="MT">Montana</option>';
        code += '<option value="NE">Nebraska</option>';
        code += '<option value="NV">Nevada</option>';
        code += '<option value="NH">New Hampshire</option>';
        code += '<option value="NJ">New Jersey</option>';
        code += '<option value="NM">New Mexico</option>';
        code += '<option value="NY">New York</option>';
        code += '<option value="NC">North Carolina</option>';
        code += '<option value="ND">North Dakota</option>';
        code += '<option value="OH">Ohio</option>';
        code += '<option value="OK">Oklahoma</option>';
        code += '<option value="OR">Oregon</option>';
        code += '<option value="PA">Pennsylvania</option>';
        code += '<option value="RI">Rhode Island</option>';
        code += '<option value="SC">South Carolina</option>';
        code += '<option value="SD">South Dakota</option>';
        code += '<option value="TN">Tennessee</option>';
        code += '<option value="TX">Texas</option>';
        code += '<option value="UT">Utah</option>';
        code += '<option value="VT">Vermont</option>';
        code += '<option value="VA">Virginia</option>';
        code += '<option value="WA">Washington</option>';
        code += '<option value="WV">West Virginia</option>';
        code += '<option value="WI">Wisconsin</option>';
        code += '<option value="WY">Wyoming</option>';
        code += '</select>';
        code += '</div>';
        code += '<div class="form-item item-half">';
        code += '<input type="text" id="fzip" name="$zip" value="" placeholder="Zip" >';
        code += '</div>';
        code += '</div>';
        code += '<input type="hidden" name="list-id" value="'+list_id+'">';
        code += '<input class="submit-btn" type="submit" value="send my booklet now">';
        code += '</form>';
        code += '</div>';
        code += '</div>';
      }else if(width=='article-width'){  //Article Width
        code += '<h4 class="booklet-sub-heading">Get your free hard copy of Dr. Schultz’s booklet</h4>';
        code += '<h2 class="booklet-heading">Prescription for Gorgeous Skin</h2>';
        code += '<p class="small-text-booklet">Includes our digital newsletter — where Dr. Schultz shares his best tips and tricks</p>';
        code += '<div class="wr-image-booklet">';
        code += '<img class="img-booklet" src="//www.beautyrx.com/cdn/shop/t/101/assets/booklet.png?v=114438889822592106531764047831" alt/>';
        code += '</div>';
        code += '<div class="wrapp-form-booklet">';
        code += '<form id="hard-copy-form" class="klaviyo_gdpr_embed_'+list_id+' hard-copy-form" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate">';
        code +=	'<input type="hidden" name="g" value="'+list_id+'">';
        code += '<input type="hidden" name="$fields" value="First Name,Address,City,State,Zip">';
        code += '<input type="hidden" name="$list_fields" value="First Name,Address,City,State,Zip">';
        code += '<div class="form-group">';
        code += '<div class="form-item">';
        code += '<input type="text" id="fname" name="First Name" value="" placeholder="Full Name" >';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="email" id="email" class="email" name="email" placeholder="Email" required/>';
        code += '</div>';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="text" id="street-address" name="Address" value="" placeholder="Street Address" >';
        code += '</div>';
        code += '<div class="form-group">';
        code += '<div class="form-item">';
        code += '<input type="text" id="fcity" name="City" value="" placeholder="City" >';
        code += '</div>';
        code += '<div class="form-item item-half">';
        code += '<select name="State" id="state">';
        code += '<option value="" selected="selected">State</option>';
        code += '<option value="AL">Alabama</option>';
        code += '<option value="AK">Alaska</option>';
        code += '<option value="AZ">Arizona</option>';
        code += '<option value="AR">Arkansas</option>';
        code += '<option value="CA">California</option>';
        code += '<option value="CO">Colorado</option>';
        code += '<option value="CT">Connecticut</option>';
        code += '<option value="DE">Delaware</option>';
        code += '<option value="DC">District Of Columbia</option>';
        code += '<option value="FL">Florida</option>';
        code += '<option value="GA">Georgia</option>';
        code += '<option value="HI">Hawaii</option>';
        code += '<option value="ID">Idaho</option>';
        code += '<option value="IL">Illinois</option>';
        code += '<option value="IN">Indiana</option>';
        code += '<option value="IA">Iowa</option>';
        code += '<option value="KS">Kansas</option>';
        code += '<option value="KY">Kentucky</option>';
        code += '<option value="LA">Louisiana</option>';
        code += '<option value="ME">Maine</option>';
        code += '<option value="MD">Maryland</option>';
        code += '<option value="MA">Massachusetts</option>';
        code += '<option value="MI">Michigan</option>';
        code += '<option value="MN">Minnesota</option>';
        code += '<option value="MS">Mississippi</option>';
        code += '<option value="MO">Missouri</option>';
        code += '<option value="MT">Montana</option>';
        code += '<option value="NE">Nebraska</option>';
        code += '<option value="NV">Nevada</option>';
        code += '<option value="NH">New Hampshire</option>';
        code += '<option value="NJ">New Jersey</option>';
        code += '<option value="NM">New Mexico</option>';
        code += '<option value="NY">New York</option>';
        code += '<option value="NC">North Carolina</option>';
        code += '<option value="ND">North Dakota</option>';
        code += '<option value="OH">Ohio</option>';
        code += '<option value="OK">Oklahoma</option>';
        code += '<option value="OR">Oregon</option>';
        code += '<option value="PA">Pennsylvania</option>';
        code += '<option value="RI">Rhode Island</option>';
        code += '<option value="SC">South Carolina</option>';
        code += '<option value="SD">South Dakota</option>';
        code += '<option value="TN">Tennessee</option>';
        code += '<option value="TX">Texas</option>';
        code += '<option value="UT">Utah</option>';
        code += '<option value="VT">Vermont</option>';
        code += '<option value="VA">Virginia</option>';
        code += '<option value="WA">Washington</option>';
        code += '<option value="WV">West Virginia</option>';
        code += '<option value="WI">Wisconsin</option>';
        code += '<option value="WY">Wyoming</option>';
        code += '</select>';
        code += '</div>';
        code += '<div class="form-item item-half">';
        code += '<input type="text" id="fzip" name="Zip" value="" placeholder="Zip" >';
        code += '</div>';
        code += '</div>';
        code += '<div style="text-align:center;" class="klaviyo_messages">';
        code += '<div style="color: #009271;" class="success_message" style="display:none;"></div>';
        code += '<div style="color: red;" class="error_message" style="display:none;"></div>';
        code += '</div>';
        code += '<div class="klaviyo_form_actions">';
        code += '<input type="hidden" name="list-id" value="'+list_id+'">';
        code += '<input class="submit-btn" type="submit" value="send my booklet now">';
        code += '</div>';
        code += '</form>';
        code += '</div>';
        code += '<script type="text/javascript" src="//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"></script>';
      }else if(width=='half-article-width'){ //Half Article Width
        code += '<h4 class="booklet-sub-heading">Get your free hard copy of';
        code += '<span>Dr. Schultz’s booklet:</span></h4>';
        code += '<h2 class="booklet-heading">Prescription for Gorgeous Skin</h2>';
        code += '<p class="small-text-booklet">Includes our digital newsletter — where Dr. Schultz shares his best tips and tricks</p>';
        code += '<div class="wr-image-booklet">';
        code += '<img class="img-booklet" src="//www.beautyrx.com/cdn/shop/t/101/assets/booklet.png?v=114438889822592106531764047831" alt/>';
        code += '</div>';
        code += '<div class="wrapp-form-booklet">';
        code += '<form id="hard-copy-form" class="klaviyo_gdpr_embed_'+list_id+' hard-copy-form" action="//manage.kmail-lists.com/subscriptions/subscribe" data-ajax-submit="//manage.kmail-lists.com/ajax/subscriptions/subscribe" method="GET" target="_blank" novalidate="novalidate">';
        code +=	'<input type="hidden" name="g" value="'+list_id+'">';
        code += '<input type="hidden" name="$fields" value="First Name,Address,City,State,Zip">';
        code += '<input type="hidden" name="$list_fields" value="First Name,Address,City,State,Zip">';
        code += '<div class="form-item">';
        code += '<input type="text" id="fname" name="First Name" value="" placeholder="Full Name" >';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="email" id="email" class="email" name="email" placeholder="Email" required/>';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="text" id="street-address" name="Address" value="" placeholder="Street Address" >';
        code += '</div>';
        code += '<div class="form-item">';
        code += '<input type="text" id="fcity" name="City" value="" placeholder="City" >';
        code += '</div>';
        code += '<div class="form-group">';
        code += '<div class="form-item">';
        code += '<select name="State" id="state">';
        code += '<option value="" selected="selected">State</option>';
        code += '<option value="AL">Alabama</option>';
        code += '<option value="AK">Alaska</option>';
        code += '<option value="AZ">Arizona</option>';
        code += '<option value="AR">Arkansas</option>';
        code += '<option value="CA">California</option>';
        code += '<option value="CO">Colorado</option>';
        code += '<option value="CT">Connecticut</option>';
        code += '<option value="DE">Delaware</option>';
        code += '<option value="DC">District Of Columbia</option>';
        code += '<option value="FL">Florida</option>';
        code += '<option value="GA">Georgia</option>';
        code += '<option value="HI">Hawaii</option>';
        code += '<option value="ID">Idaho</option>';
        code += '<option value="IL">Illinois</option>';
        code += '<option value="IN">Indiana</option>';
        code += '<option value="IA">Iowa</option>';
        code += '<option value="KS">Kansas</option>';
        code += '<option value="KY">Kentucky</option>';
        code += '<option value="LA">Louisiana</option>';
        code += '<option value="ME">Maine</option>';
        code += '<option value="MD">Maryland</option>';
        code += '<option value="MA">Massachusetts</option>';
        code += '<option value="MI">Michigan</option>';
        code += '<option value="MN">Minnesota</option>';
        code += '<option value="MS">Mississippi</option>';
        code += '<option value="MO">Missouri</option>';
        code += '<option value="MT">Montana</option>';
        code += '<option value="NE">Nebraska</option>';
        code += '<option value="NV">Nevada</option>';
        code += '<option value="NH">New Hampshire</option>';
        code += '<option value="NJ">New Jersey</option>';
        code += '<option value="NM">New Mexico</option>';
        code += '<option value="NY">New York</option>';
        code += '<option value="NC">North Carolina</option>';
        code += '<option value="ND">North Dakota</option>';
        code += '<option value="OH">Ohio</option>';
        code += '<option value="OK">Oklahoma</option>';
        code += '<option value="OR">Oregon</option>';
        code += '<option value="PA">Pennsylvania</option>';
        code += '<option value="RI">Rhode Island</option>';
        code += '<option value="SC">South Carolina</option>';
        code += '<option value="SD">South Dakota</option>';
        code += '<option value="TN">Tennessee</option>';
        code += '<option value="TX">Texas</option>';
        code += '<option value="UT">Utah</option>';
        code += '<option value="VT">Vermont</option>';
        code += '<option value="VA">Virginia</option>';
        code += '<option value="WA">Washington</option>';
        code += '<option value="WV">West Virginia</option>';
        code += '<option value="WI">Wisconsin</option>';
        code += '<option value="WY">Wyoming</option>';
        code += '</select>';
        code += '</div>';
        code += '<div class="form-item ">';
        code += '<input type="text" id="fzip" name="Zip" value="" placeholder="Zip" >';
        code += '</div>';
        code += '</div>';
        code += '<div style="text-align:center;" class="klaviyo_messages">';
        code += '<div style="color: #009271;" class="success_message" style="display:none;"></div>';
        code += '<div style="color: red;" class="error_message" style="display:none;"></div>';
        code += '</div>';
        code += '<div class="klaviyo_form_actions">';
        code += '<input type="hidden" name="list-id" value="'+list_id+'">';
        code += '<input class="submit-btn" type="submit" value="send my booklet now">';
        code += '</div>';
        code += '</form>';
        code += '</div>';
        code += '<script type="text/javascript" src="//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"></script>';
      }          
      $this.html(code);
    }
  });

  KlaviyoSubscribe.attachToForms('#hard-copy-form', {
    hide_form_on_success: true,
    extra_properties: {
      $source: 'Hard Copy Form',
      $method_type: "Digital Booklet Inline With Content",
      $method_id: 'Embed',
      success: function ($form) {
        console.log("Submit Klaviyo Success");
      }
    },
    success_message: "Thanks for subscribing! Please check your email."
  });
  
  //Submit
  /*
  $(document).on('submit', '.hard-copy-form', function(e) {
    e.preventDefault();
    var $form = $(this);
    var formData = $form.serialize();
    var code = Math.random().toString(36).substring(2, 12); 
    $.ajax({
      type        : 'POST',
      url		  : "/apps/beautyrx/product-cta-module/form.php?function=save-klaviyo-list&code="+code,
      data        : formData,
      dataType    : 'json',
      encode      : true
    }).done(function(data) {
      if(data.success){
        $form.html('<p style="text-align:center;">Thanks for subscribing! Please check your email.</p>');
      }else{
        alert(data.message);
      }      
    });
  });
  */

  //email_signup_sidebar
  $(document).on('submit', '#email_signup_sidebar', function(e) {
    e.preventDefault();
    var $form = $(this);
    var formData = $form.serialize();
    var code = Math.random().toString(36).substring(2, 12); 
    $.ajax({
      type        : 'POST',
      url		  : "/apps/beautyrx/product-cta-module/form.php?function=save-klaviyo-list&code="+code,
      data        : formData,
      dataType    : 'json',
      encode      : true
    }).done(function(data) {
      if(data.success){
        $form.html('<p style="text-align:center;">Thanks for subscribing! Please check your email.</p>');
      }else{
        alert(data.message);
      }      
    });
  });

  
  //ARTICLE - Embed module DR. NEAL SCHULTZ SAYS
  $('.dr-schultz-says').each(function(){
    var $this = $(this);
    var text = $(this).text();
    console.log(text);
    if (text == "" || text == null) {
      text = "It's not just about lines and wrinkles, but instead it's about finding the right treatments and skincare regimen for your skin, which we will help you do at BeautyRx.";
    }
    console.log(text);
    var code = '';
    code += '<div class="wr-dr-schultz-says">';
    code += '<div class="container">';
    code += ' <div class="row align-items-center">';
    code += ' <div class="col-md-3">';
    code += '  <img data-src="//www.beautyrx.com/cdn/shop/t/101/assets/img_dr_schultz.png?v=6483418415956721011764047950" class="lazyload" />';
    code += ' </div>';
    code += ' <div class="col-md-9">';
    code += '   <p>award winning dermatologist dr. neal schultz says:</p>';
    code += '   <h4>'+text+'</h4>';
    code += ' </div>';
    code += '</div>';
    code += ' </div>';
    code += '</div>';
    
    $this.show().html(code);

  });


});





